import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";
import styles from "../styles/Navbar.module.css";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location.pathname]);

  const close = () => setMenuOpen(false);

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ""}`}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo} onClick={close} aria-label="Home">
          <img src="/my-photo.png" alt="Mercy Mofoluwawo" className={styles.logoPhoto} />
        </Link>

        <div className={`${styles.menu} ${menuOpen ? styles.open : ""}`}>
          <Link to="/work" onClick={close}>Work</Link>
          <Link to="/speaking" onClick={close}>Speaking</Link>
          <Link to="/writing" onClick={close}>Writing</Link>
          <Link to="/about" onClick={close}>About</Link>
          <a
            href="mailto:mmofoluwawo@gmail.com"
            className={styles.emailLink}
            onClick={close}
          >
            Email ↗
          </a>
        </div>

        <div className={styles.rightControls}>
          <ThemeToggle />
          <button
            className={`${styles.burger} ${menuOpen ? styles.burgerOpen : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
